import { ServiceLocator } from '../../../app/ServiceLocator';
import { SpaceInfo } from '../../../app/state/SpaceInfo';
import { IContentInfo } from '../../../ts/models/IContentInfo';
import { TelemetryService } from '../../../ts/services/TelemetryService';
import { ContentTelemetryEvents, TelemetryEvents } from '../TelemetryEvents';
import {
  ContentClickedEvent,
  ContentLocation,
  ContentTelemetryCommonData,
  ContentTelemetryContextSpecificData,
  FavoriteToggleClickedEvent,
  FavoriteToggleType,
  isExploreData,
  isHomeData
} from '../types/ContentTelemetryTypes';

export function generateTelemetryEventHandler(
  type: ContentTelemetryEvents,
  spaceInfo: SpaceInfo,
  contentInfo: IContentInfo,
  contentLocation: ContentLocation,
  contentPosition: number,
  specificData: ContentTelemetryContextSpecificData): (...args: any[]) => void {
  const telemetryService: TelemetryService = ServiceLocator.get<TelemetryService>('TelemetryService');
  const commonData: ContentTelemetryCommonData = {
    contentId: contentInfo.id,
    contentType: contentInfo.contentType,
    contentLocation: contentLocation,
    space: spaceInfo.spaceType,
    subspace: spaceInfo.subspaceName,
    contentPosition: contentPosition,
  };

  switch (type) {
    case TelemetryEvents.ContentClicked: {
      return function onContentClick() {
        telemetryService.sendEvent<ContentClickedEvent>(
          { ...commonData, ...specificData, type: TelemetryEvents.ContentClicked }
        );
      };
    }
    case TelemetryEvents.FavoriteToggleClicked: {
      return function onFavoriteToggleClick(toggleType: FavoriteToggleType) {
        telemetryService.sendEvent<FavoriteToggleClickedEvent>(
          { ...commonData, ...specificData, type: TelemetryEvents.FavoriteToggleClicked, toggleType }
        );
      };
    }
    case TelemetryEvents.ActionMenuItemClicked: {
      return function onActionMenuItemClick() {
        //TODO: add action menu items click telemetry in future. TFS: 912935
      };
    }
  }
}
